import React from 'react';

import {
    Checkbox, Select, Stack, TextInput, Title,
} from '@mantine/core';

import { ControlPageBlock } from '../blocks/edit_blocks';
import Fetcher from '../common/communicate';
import { PROJECT_PREFIX } from '../const';

export default class AuthorEditScreen extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: {
                email: '',
                nick: '',
                like_hammer: 0,
            },
            not_valid: {},
            loading: true,

        };
        this.handleChange = this.handleChange.bind(this);
        this.sendData = this.sendData.bind(this);
        this.removeData = this.removeData.bind(this);
        this.goToPreviousPage = this.goToPreviousPage.bind(this);
        this.handleData = this.handleData.bind(this);

        if (props.match.params.authorEmail) {
            this.API_ENDPOINT = `authors/${props.match.params.authorEmail}/`;
        } else {
            this.API_ENDPOINT = 'authors/';
            this.EDITABLE_EMAIL = true;
        }
    }

    handleData(data) {
        this.setState({ loading: false, data });
    }

    sendData(event) {
        this.validate();

        let request_method = 'PUT';

        if (!this.props.match.params.authorEmail) {
            request_method = 'POST';
        }

        const save_type = event.currentTarget.id;

        // TODO: sorry about that, but its all about DB structure
        if (!this.state.data.like_hammer) {
            const new_state = this.state;
            new_state.data.like_hammer = 0;
            this.setState(new_state);
        }

        //
        let callback = this.handleData;

        if (save_type === 'save_button') {
            callback = this.goToPreviousPage;
        }

        Fetcher(this.API_ENDPOINT, request_method, callback, this.state.data);
    }

    goToPreviousPage() {
        this.props.history.push(`${PROJECT_PREFIX}/authors/all`);
    }

    removeData() {
        Fetcher(this.API_ENDPOINT, 'DELETE', this.goToPreviousPage);
    }

    handleRoleChange = (newRole) => {
        const { data } = this.state;

        this.setState({
            data: {
                ...data,
                ugc_role: newRole,
            },
        });
    };

    handleChange(event) {
        let state = event.currentTarget.value;

        if (event.currentTarget.type === 'checkbox') {
            if (event.currentTarget.checked) {
                state = 1;
            } else {
                state = 0;
            }
        }

        const new_state = this.state;
        new_state.data[event.currentTarget.name] = state;
        this.setState(new_state);
    }

    componentDidMount() {
        if (this.props.match.params.authorEmail) {
            Fetcher(this.API_ENDPOINT, 'GET', this.handleData);
        } else {
            this.setState({
                loading: false,
                data: {
                    nick: '',
                    email: '',
                    like_hammer: 0,
                    is_reviewer: 0,
                },
            });
        }
    }

    validate() {
        const no_valid_fields = {};
        const req_fields = ['email', 'nick'];

        for (let i = 0; i < Object.keys(req_fields).length; i++) {
            if (!this.state.data[req_fields[i]]) {
                no_valid_fields[req_fields[i]] = true;
            }
        }

        this.setState({ not_valid: Object.assign(this.state.not_valid, no_valid_fields) });
    }

    render() {
        if (this.state.loading) {
            return null;
        }

        return (
            <div>
                <div className="container">
                    <Title order={3} mb="xl">
                        Автор:
                        {' '}
                        {this.state.data.nick}
                    </Title>
                    <Stack spacing="sm" maw={800}>
                        <TextInput
                            name="email"
                            label="Email"
                            value={this.state.data.email}
                            onChange={this.handleChange}
                            disabled={!this.EDITABLE_EMAIL} // TODO: change foreignKey to ID and del this
                            required
                            error={this.state.not_valid.email || false}
                        />
                        <TextInput
                            name="sezam_user_id"
                            label="Sezam ID"
                            value={this.state.data.sezam_user_id}
                            onChange={this.handleChange}
                        />
                        <TextInput
                            name="nick"
                            label="Ник"
                            value={this.state.data.nick}
                            onChange={this.handleChange}
                            required
                            error={this.state.not_valid.nick || false}
                        />
                        <Select
                            size="sm"
                            name="ugc_role"
                            label="UGC-роль"
                            value={this.state.data.ugc_role}
                            onChange={this.handleRoleChange}
                            data={[
                                {
                                    value: 'user',
                                    label: 'Пользователь',
                                },
                                {
                                    value: 'freelancer',
                                    label: 'Фрилансер',
                                },
                                {
                                    value: 'moderator',
                                    label: 'Редактор',
                                },
                                {
                                    value: 'superuser',
                                    label: 'Суперюзер',
                                },
                            ]}
                        />
                        <Stack spacing="sm">
                            <Checkbox
                                name="like_hammer"
                                label="Like hammer"
                                checked={!!this.state.data.like_hammer}
                                onChange={this.handleChange}
                            />
                            <Checkbox
                                name="is_reviewer"
                                label="Ревьювер"
                                checked={this.state.data.is_reviewer}
                                onChange={this.handleChange}
                            />
                        </Stack>
                        <ControlPageBlock
                            name={this.state.data.nick}
                            onSave={this.sendData}
                            onApply={this.sendData}
                            onRemove={this.removeData}
                            onCancel={this.goToPreviousPage}
                        />
                    </Stack>
                </div>
            </div>
        );
    }
}
